import { tabletQuery } from '@globals/themes/themeConstants'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'

/**
 * Temporary layout for when we are on a page that doesn't have
 * an app bar (this is currently only an edge case for login pages)
 */

const noAppBarLayoutStyle: SxProps = {
  margin: 'auto',
  overflow: 'visible',
  [tabletQuery]: {
    mx: 0,
    mt: -6, // offsets the app bar margins that are set at the app root level
  },
}

type NoAppBarLayoutProps = {
  maxWidth?: number
  children?: React.ReactNode
}
const NoAppBarLayout: React.FC<NoAppBarLayoutProps> = ({ children, maxWidth }) => (
  <Box sx={noAppBarLayoutStyle} maxWidth={maxWidth}>
    {children}
  </Box>
)

export default NoAppBarLayout
